import { Doughnut } from "react-chartjs-2";

// 장루 분포 그래프
const JangruGraph = ({ flexCol, graphData, options, data }) => {
  return (
    <>
      <p className="flex-none font-extrabold text-[18px] ">장루 분포</p>
      <div className="flex items-end justify-between w-full h-full grow">
        <div
          className="flex aspect-square w-full min-w-[160px] mr-6"
          style={{ maxWidth: flexCol ? "160px" : "240px" }} // flexCol일 경우에 그래프 최대크기는 160px
        >
          <Doughnut data={graphData} options={options} />
        </div>
        <div className="flex flex-col justify-end items-end h-full gap-y-3 text-[#020A1B]">
          <div className="flex justify-between w-[171px] text-base leading-[22px]">
            <p className="text-[#8EA0FF] mr-1">
              ●<span className="text-[#020A1B] ml-1">공장루</span>
            </p>
            <p className="font-semibold">{data[0].type1}명</p>
          </div>
          <div className="flex justify-between w-[171px] text-base leading-[22px]">
            <p className="text-[#FFBBBB] mr-1">
              ●<span className="text-[#020A1B] ml-1">횡행결장루</span>
            </p>
            <p className="font-semibold">{data[0].type2}명</p>
          </div>
          <div className="flex justify-between w-[171px] text-base leading-[22px]">
            <p className="text-[#94DBCA] mr-1">
              ●<span className="text-[#020A1B] ml-1">하행/구불결장루</span>
            </p>
            <p className="font-semibold">{data[0].type3}명</p>
          </div>
          <div className="flex justify-between w-[171px] text-base leading-[22px]">
            <p className="text-[#FADD79] mr-1">
              ●<span className="text-[#020A1B] ml-1">상행결장루</span>
            </p>
            <p className="font-semibold">{data[0].type4}명</p>
          </div>
          <div className="flex justify-between w-[171px] text-base leading-[22px]">
            <p className="text-[#F9BC60] mr-1">
              ●<span className="text-[#020A1B] ml-1">회장루</span>
            </p>
            <p className="font-semibold">{data[0].type5}명</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default JangruGraph;
